import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAuthHeader } from 'react-auth-kit';
import { config } from 'variables/config';

export function useActivityEvents(filters = {}, page = 0, limit = 20) {
  const authHeader = useAuthHeader();

  return useQuery({
    queryKey: ['user-activity', filters, page, limit],
    queryFn: async () => {
      const params = { ...filters, page, limit, sort: 'timestamp,desc' };
      const { data } = await axios.get(`${config.app.api_url}/user-activity`, {
        params,
        headers: { Authorization: authHeader() },
      });
      return data;
    },
    staleTime: 2 * 60 * 1000,
    keepPreviousData: true,
  });
}

export function useActivityStats(start, end) {
  const authHeader = useAuthHeader();

  return useQuery({
    queryKey: ['user-activity-stats', start, end],
    queryFn: async () => {
      const params = {};
      if (start) params.start = start;
      if (end) params.end = end;
      const { data } = await axios.get(`${config.app.api_url}/user-activity/stats`, {
        params,
        headers: { Authorization: authHeader() },
      });
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useUserActivityTimeline(userId, page = 0, limit = 20) {
  const authHeader = useAuthHeader();

  return useQuery({
    queryKey: ['user-activity-timeline', userId, page, limit],
    queryFn: async () => {
      const { data } = await axios.get(`${config.app.api_url}/users/${userId}/activity`, {
        params: { page, limit },
        headers: { Authorization: authHeader() },
      });
      return data;
    },
    enabled: !!userId,
    staleTime: 2 * 60 * 1000,
  });
}
